import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { PhoneFilled, WhatsAppOutlined } from "@ant-design/icons";

import "./header.component.styles.scss";
import { Toolbar } from "../../navigations";
import { LaviensLogo } from "../../generic";
import {
  PHONE_HUMAN,
  PHONE_TEL,
  WHATSAPP_URL,
  conversions,
} from "../../../lib/analytics";
import { useLang } from "../../../lib/i18n";

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { lang } = useLang();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`lvs-header${scrolled ? " is-scrolled" : ""}`}>
      <div className="lvs-header__inner">
        <div className="lvs-header__brand">
          <LaviensLogo />
        </div>
        <nav className="lvs-header__nav" aria-label="Primary">
          <Toolbar />
        </nav>
        <a
          href={WHATSAPP_URL}
          className="lvs-header__whatsapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp Laviens"
          onClick={() => conversions.whatsapp("header")}
        >
          <WhatsAppOutlined />
          <span className="lvs-header__whatsappLabel">WhatsApp</span>
        </a>
        <a
          href={`tel:${PHONE_TEL}`}
          className="lvs-header__call"
          aria-label={`${lang === "en" ? "Call Laviens" : "Chiama Laviens"} ${PHONE_HUMAN}`}
          title={PHONE_HUMAN}
          onClick={() => conversions.phone("header")}
        >
          <PhoneFilled />
          <span className="lvs-header__callNum">{PHONE_HUMAN}</span>
        </a>
        <Link
          to={lang === "en" ? "/en/booking" : "/booking"}
          className="lvs-header__book"
          onClick={() => conversions.book("header")}
        >
          {lang === "en" ? "Book" : "Prenota"}
        </Link>
      </div>
    </header>
  );
};

export default Header;
